<template>
  <div class="bh-page">
    <header class="bh-page-hero">
      <div v-reveal class="bh-container">
        <h1 class="bh-page-hero__title">Donate</h1>
        <p class="bh-page-hero__lead">
          Your gift supports hunter education, conservation programming, and our
          annual Black Hills banquet.
        </p>
      </div>
    </header>

    <section class="bh-section">
      <div v-reveal="{ variant: 'scale' }" class="bh-container donate-panel">
        <p class="donate-intro">
          Donate via Venmo. Scan the QR code on desktop, or use the button below
          on mobile.
        </p>
        <div class="qr-wrapper">
          <img
            :src="venmoQrUrl"
            alt="Venmo QR code for Black Hills Mountain Lion Foundation"
            width="240"
            height="240"
          />
        </div>
        <div class="donate-actions">
          <DonateButton
            variant="flat"
            color="primary"
            text="Donate with Venmo"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DonateButton, { VENMO_QR_URL } from "../components/DonateButton.vue";

export default {
  name: "DonatePage",
  components: {
    DonateButton,
  },
  data() {
    return {
      venmoQrUrl: VENMO_QR_URL,
    };
  },
};
</script>

<style scoped>
.donate-panel {
  max-width: 32rem;
  margin-inline: auto;
  background: var(--bh-surface);
  border: 1px solid var(--bh-border);
  border-radius: var(--bh-radius);
  box-shadow: var(--bh-shadow);
  padding: 2.25rem 1.75rem;
  text-align: center;
}

.donate-intro {
  margin: 0 0 1.5rem;
  color: var(--bh-muted);
  line-height: 1.55;
}

.qr-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.qr-wrapper img {
  border: 1px solid var(--bh-border);
  border-radius: 8px;
  background: #fff;
  padding: 0.75rem;
}

.donate-actions {
  display: flex;
  justify-content: center;
}
</style>
